// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as PartnerPenaltyRepoManager from "../repo/PartnerPenaltyRepoManager.bs.js";

function fetchManualPenaltyList(order_id, msisdn, country, onSuccess, onFailure) {
  var RepoInstance = PartnerPenaltyRepoManager.getPartnerPenaltyRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchManualPenaltyList, msisdn, order_id, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function createManualPenalty(payload, country, onSuccess, onFailure) {
  var RepoInstance = PartnerPenaltyRepoManager.getPartnerPenaltyRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.createManualPenalty, payload, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchPartnerPenalties(order_crn, msisdn, start_date, end_date, country, onSuccess, onFailure) {
  var RepoInstance = PartnerPenaltyRepoManager.getPartnerPenaltyRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._5(RepoInstance.fetchPartnerPenalties, Belt_Option.getWithDefault(order_crn, ""), Belt_Option.getWithDefault(msisdn, ""), start_date !== undefined ? Timestamp$Catalyst.toFloat(Caml_option.valFromOption(start_date)).toString() : "", end_date !== undefined ? Timestamp$Catalyst.toFloat(Caml_option.valFromOption(end_date)).toString() : "", country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function deletePartnerPenalty(payload, country, onSuccess, onFailure) {
  var RepoInstance = PartnerPenaltyRepoManager.getPartnerPenaltyRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.deletePartnerPenalty, payload, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

export {
  fetchManualPenaltyList ,
  createManualPenalty ,
  fetchPartnerPenalties ,
  deletePartnerPenalty ,
  
}
/* Timestamp-Catalyst Not a pure module */
